import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { useFilters as useTimeSheetFilters } from "../../../../TimeSheet/Home/Actions/useFilters";

import { useEmployeeNumberFilter } from "../../../../TimeSheet/Team/Actions/useFilters/useEmployeeNumberFilter";
import { useProjectFilter } from "../../../../TimeSheet/Team/Actions/useFilters/useProjectFilter";
import { useUnionFilter } from "../../../../TimeSheet/Team/Actions/useFilters/useUnionFilter";
import { useCalculationGroupFilter } from "../../../../TimeSheet/Team/Actions/useFilters/useCalculationGroupFilter";
import { useUserFilters } from "../hooks/useUserFilters";

export const useFilters = () => {
    const { t } = useTranslation();

    const employeeNumberFilter = useEmployeeNumberFilter();
    const timeSheetFilters = useTimeSheetFilters();

    const levelFilters = useMemo(() => {
        return timeSheetFilters.filter(({ id }) => id.indexOf('level') === 0);
    }, [timeSheetFilters]);

    const otherTimesheetFilters = useMemo(() => {
        return timeSheetFilters.filter(({ id }) => !(id.indexOf('level') === 0));
    }, [timeSheetFilters])

    const projectFilter = useProjectFilter();
    const calculationGroupFilter = useCalculationGroupFilter();
    const unionFilter = useUnionFilter();
    const { userGroupFilter, employmentTypeFilter, salaryOrHourlyFilter, customFieldsFilters } = useUserFilters();

    const filters = useMemo(() => [
        {
            Header: t("name"),
            id: "search"
        },
        employeeNumberFilter,
        ...levelFilters,
        {
            id: "payGroup",
            Header: t("pay-group"),
            canFilter: true,
            filter: "resource-select",
            disableFilters: false,
        },
        projectFilter,
        calculationGroupFilter,
        unionFilter,
        userGroupFilter,
        employmentTypeFilter,
        salaryOrHourlyFilter,
        ...otherTimesheetFilters,
        ...customFieldsFilters,
    ], [
        employeeNumberFilter,
        levelFilters,
        projectFilter,
        calculationGroupFilter,
        unionFilter,
        otherTimesheetFilters,
        userGroupFilter,
        employmentTypeFilter,
        salaryOrHourlyFilter,
        customFieldsFilters,
        t
    ]);

    return useMemo(() => filters.map((filter: any) => ({
        ...filter,
        name: filter.id,
        label: filter.Header,
    })), [filters]);
}
